var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxOutlineChart4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2 22.75c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h20c.41 0 .75.34.75.75s-.34.75-.75.75H2z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.75 22.75c-.41 0-.75-.34-.75-.75V4c0-1.72.95-2.75 2.55-2.75h.9C14.05 1.25 15 2.28 15 4v18c0 .41-.34.75-.75.75h-4.5zm3.75-1.5V4c0-1.15-.54-1.25-1.05-1.25h-.9c-.51 0-1.05.1-1.05 1.25v17.25h3zM3 22.75c-.41 0-.75-.34-.75-.75V10c0-1.72.88-2.75 2.35-2.75h.8c1.47 0 2.35 1.03 2.35 2.75v12c0 .41-.34.75-.75.75H3zm3.25-1.5V10c0-1.25-.55-1.25-.85-1.25h-.8c-.3 0-.85 0-.85 1.25v11.25h2.5zM17 22.75c-.41 0-.75-.34-.75-.75v-7c0-1.72.88-2.75 2.35-2.75h.8c1.47 0 2.35 1.03 2.35 2.75v7c0 .41-.34.75-.75.75h-4zm3.25-1.5V15c0-1.25-.55-1.25-.85-1.25h-.8c-.3 0-.85 0-.85 1.25v6.25h2.5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxOutlineChart4);
export default __webpack_public_path__ + "static/media/vuesax-outline-chart-4.ba2aee6864979db64727b8dd9dec96ae.svg";
export { ForwardRef as ReactComponent };